/**
 * 基础菜单 购卡记录
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>购卡记录</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：" v-if="systemFlag == 1">
        <el-select size="small" v-model="queryParams.orgName" placeholder="请选择客户名称" clearable>
          <el-option v-for="x in clientList" :label="x.orgName" :value="x.orgName" :key="x.orgName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="systemFlag != 1 ? '搜索：' : ''">
        <el-input size="small" v-model="queryParams.name" placeholder="输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.phone" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.idcard" placeholder="输入身份证号码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      :key="color_index"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      height="calc(100vh - 250px)"
      style="width: 100%;"
    >
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="orgName" label="客户名称"/>
      <el-table-column prop="name" label="姓名"/>
      <el-table-column prop="phone" label="手机号"/>
      <el-table-column prop="idcard" label="身份证号"/>
      <el-table-column prop="wxName" label="绑定微信号"/>
      <el-table-column prop="subjectName" label="考试科目"/>
      <el-table-column prop="payTime" label="购卡时间"/>
      <el-table-column prop="price" label="购买金额"/>
      <el-table-column prop="validTime" label="卡到期时间"/>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather" style="position: fixed; bottom: 2vh;"></Pagination>

  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import axios from "axios";
import Template from "../../components/template";
import {queryBuyCardList, querySendCardList} from "../../api/order";
import {queryOrgList} from "../../api/userMG";
export default {
  data() {
    return {
      systemFlag: JSON.parse(localStorage.getItem('userdata')).systemFlag,
      color_index: 0,
      loading: false, //是显示加载
      queryParams: {
        page: 1,
        size: 10
      },
      listData: [], //用户数据

      clientList: [], // 客户下拉选 数据

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
   }
  },
  // 注册组件
  components: {
    Template,
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.initData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    changeColor(name) {
      const newStr = name.replace(/“([^“”]*)”/g, '<span style="color: red;">$1</span>');
      return newStr;
    },
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata();

      // admin 账号 查询客户下拉选
      queryOrgList({page: 1, size: 1000}).then(res => {
        this.clientList = res.data.content
      })
    },

    // 获取列表
    getdata() {
      // this.identificationRecognize();
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryBuyCardList(this.queryParams).then(res => {
          this.loading = false
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm = res.data.pageparm
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },

    // 搜索事件
    search() {
      this.getdata()
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.tree-con {
  width: 250px;
  height: 95%;
  vertical-align: text-top;
  margin-top: 20px;
  display: inline-block;
  border: #544E4F 2px solid;
  border-radius: 8px;
}

</style>





// WEBPACK FOOTER //
// src/views/order/buyCard.vue